export interface AppConfig {
  apiBaseUrl: string;
  baseDomain: string;
  agentDownloadUrl: string;
  bootstrapperDownloadUrl: string;
  appInsightsConnectionString?: string;
  /**
   * Libera a troca de idioma (WI 148). Ausente ou false = produto so em pt-BR:
   * seletores escondidos e deteccao por navegador/perfil desligada.
   */
  i18nEnabled?: boolean;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Failed to load /config.json: ${res.status} ${res.statusText}`);
  }
  cached = (await res.json()) as AppConfig;
  return cached;
}

export function getConfig(): AppConfig {
  if (!cached) {
    throw new Error('Config not loaded. Call loadConfig() and await it before app render.');
  }
  return cached;
}

/**
 * Feature flag do i18n. Default DESLIGADO de proposito: enquanto a traducao nao esta
 * liberada, um config.json sem o campo — pipeline nao atualizado, ambiente novo — precisa
 * cair no comportamento seguro (pt-BR), nunca expor a feature por omissao.
 *
 * Seguro de chamar antes do loadConfig: sem config carregada devolve false em vez de lancar,
 * porque o i18n inicializa no import do modulo, antes do fetch do /config.json resolver.
 */
export function isI18nEnabled(): boolean {
  return cached?.i18nEnabled === true;
}
